export default __webpack_public_path__ + "static/media/info1.6b73b63f.jpg";